import { render, staticRenderFns } from "./ListAuthor.vue?vue&type=template&id=2f9bfdd8"
import script from "./ListAuthor.vue?vue&type=script&lang=js"
export * from "./ListAuthor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports